import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import MeterUsageLine from './MeterUsageLine';
import { useGetSubscriptionUsageHandler } from '../dataHandlers/getSubscriptionUsageHandler';

export default function SubscriptionCurrentUsage({ subscriptionId, periodStart, periodEnd }) {
  const hasPeriod = periodStart != null && periodEnd != null;
  const { usage, isLoading, isError } = useGetSubscriptionUsageHandler(
    subscriptionId,
    { period_start: periodStart, period_end: periodEnd },
    { enabled: hasPeriod },
  );

  if (!hasPeriod) {
    return (
      <Typography variant="body2" color="text.secondary">
        NA
      </Typography>
    );
  }

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (isError || !usage?.items?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No usage data
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5}>
      {usage.items.map((item) => (
        <MeterUsageLine key={item.meter_id} {...item} />
      ))}
    </Stack>
  );
}
